var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-child',{key:_vm.$route.params.slug})
}
var staticRenderFns = []

export { render, staticRenderFns }